export default __webpack_public_path__ + "static/media/soren.2d0a6b38.jpg";